import { observer } from "mobx-react-lite";
import { useContext } from "react";

import { Pivot, PivotItem, Stack } from "@bps/fluent-ui";

import { AppointmentInformationModalContext } from "./AppointmentInformationModalContext.ts";
import {
  AppointmentInformationModalInnerProps,
  PrefAndInformationPivotTabTypes
} from "./AppointmentInformationPivotTabs.types.ts";
import { AppointmentInformationTable } from "./AppointmentInformationTable.tsx";

type PreferencesInformationPivotTabsValues = {
  itemKey: PrefAndInformationPivotTabTypes;
  headerText: PrefAndInformationPivotTabTypes;
};

export const AppointmentInformationPivotTabs = observer(
  (props: AppointmentInformationModalInnerProps) => {
    const pivotTabs: PreferencesInformationPivotTabsValues[] = [
      {
        itemKey: PrefAndInformationPivotTabTypes.Upcoming,
        headerText: PrefAndInformationPivotTabTypes.Upcoming
      },
      {
        itemKey: PrefAndInformationPivotTabTypes.Past,
        headerText: PrefAndInformationPivotTabTypes.Past
      }
    ];

    const helper = useContext(AppointmentInformationModalContext);

    return (
      <Stack verticalFill tokens={{ childrenGap: 8 }}>
        <Pivot
          styles={{ linkIsSelected: { paddingLeft: 10 } }}
          defaultSelectedKey={PrefAndInformationPivotTabTypes.Upcoming}
        >
          {pivotTabs.map(pivotItem => (
            <PivotItem
              key={pivotItem.itemKey}
              headerText={
                pivotItem.headerText +
                (pivotItem.itemKey ===
                  PrefAndInformationPivotTabTypes.Upcoming &&
                helper.upcomingAppointmentNumber
                  ? ` (${helper.upcomingAppointmentNumber})`
                  : "")
              }
              itemKey={pivotItem.itemKey}
            >
              <AppointmentInformationTable
                contactId={props.contactId}
                claimId={props.claimId}
                onDismiss={props.onDismissInfoModal}
                selectedTab={pivotItem.itemKey}
              />
            </PivotItem>
          ))}
        </Pivot>
      </Stack>
    );
  }
);
